import { useCallback } from 'react';
import debounce from 'lodash/debounce';
import {patchWidget} from "../utils/api";
import {debounceInterval} from "../utils/globals";

export const usePlotAndValidateField = ({
  id,
  tool,
  flagTriggers,
  flagValidators,
  flagDepsRef,
  multipleWidgetSetter,
  handleDataUpdating,
  handleErrorSetting,
  pushApiCount,
}) => {
  // Wrap the debounced function in useCallback so that it only changes when its dependencies do.
  return useCallback(
    debounce((widget, k, v) => {
      pushApiCount();
      if (flagTriggers[widget]?.[k]) {
        // Get the validated widget and parameters.
        const { widget_: widget_, params_: params_ } = flagValidators(
          widget,
          k,
          v,
          flagDepsRef.current
        );
        // Update multiple widgets if needed.
        multipleWidgetSetter(params_);
        patchWidget(id, tool, widget_, params_)
          .then(response => {
            handleDataUpdating(
              response.data.tool,
              response.data.modifications,
              response.data.warnings
            );
          })
          .catch(error => {
            handleErrorSetting(error);
          });
      } else {
        patchWidget(id, tool, widget, { [k]: v })
          .then(response => {
            handleDataUpdating(
              response.data.tool,
              response.data.modifications,
              response.data.warnings
            );
          })
          .catch(error => {
            handleErrorSetting(error);
          });
      }
    }, debounceInterval),
    [
      id,
      tool,
      flagTriggers,
      flagValidators,
      flagDepsRef,
      multipleWidgetSetter,
      handleDataUpdating,
      handleErrorSetting,
      pushApiCount
    ]
  );
};
